var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.0003,
    cy: 13.5001,
    r: 10.8333,
    fill: "#0077B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1693 8.2371C10.1693 8.91153 9.65581 9.45733 8.85276 9.45733C8.08099 9.45733 7.56747 8.91153 7.58337 8.2371C7.56747 7.5299 8.08098 7 8.86814 7C9.6558 7 10.1539 7.5299 10.1693 8.2371ZM7.64793 18.277V10.4213H10.0894V18.2765H7.64793V18.277Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.046 12.9284C12.046 11.9485 12.0137 11.1132 11.9814 10.4224H14.1021L14.2148 11.4986H14.263C14.5843 11.0005 15.3873 10.2461 16.6885 10.2461C18.2946 10.2461 19.4995 11.3064 19.4995 13.6187V18.2781H17.058V13.9246C17.058 12.912 16.7049 12.2217 15.8214 12.2217C15.1465 12.2217 14.7452 12.6875 14.5848 13.137C14.5202 13.2979 14.4884 13.5224 14.4884 13.7478V18.2781H12.047V12.9284H12.046Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.29d10bb032917c9168e4e0fddc6853b7.svg";
export { ForwardRef as ReactComponent };